import { Component, Input, OnInit } from '@angular/core';
import { isEmbed } from '@local/common-web';
import { EventsService } from '@shared/services';
import { HubService } from '../../services/hub.service';

@Component({
  selector: 'apps-empty-state',
  templateUrl: './apps-empty-state.component.html',
  styleUrls: ['./apps-empty-state.component.scss'],
})
export class AppsEmptyStateComponent implements OnInit {
  private readonly isEmbed = isEmbed();
  readonly connectText = 'Connect all your apps now!';
  readonly queryText = 'Discover Unleash’s full potential by searching across all your tools.';
  readonly infoText = 'Want to search across all your databases?';

  @Input() view: 'EmptyState' | 'NoResults' | 'Banner';
  @Input() isQuery: boolean = false;

  get location() {
    return this.hubService.currentLocation;
  }

  constructor(private hubService: HubService, private eventsService: EventsService) {}

  ngOnInit(): void {
    this.eventsService.event('status_view', {
      label: this.view === 'NoResults' ? 'no_results' : 'connect_apps',
      location: { title: this.location },
      target: this.view === 'NoResults' ? null : 'connect_apps',
    });
  }

  async redirectEmptyState() {
    const url = 'connect';
    this.hubService.openUrl(url);
    this.eventsService.event('interaction_click', {
      label: this.view === 'NoResults' ? 'no_results' : 'connect_apps',
      location: { title: this.location },
      target: 'connect_apps',
    });
  }
}
